import { getApiURL, getQueryParam } from './helper';
import { PG_API_ENDPOINTS } from '@/constants';

/**
 *
 * Function to make API calls to the capital backend
 *
 * @param endpoint API endpoint
 * @param queryParams The query parameters to be appended to the URL
 * @param init The request init object
 * @param includeToken Whether to include the token in the request
 * @returns The response object
 */
const api = (
  endpoint: string,
  queryParams: Record<string, string> = {},
  init: RequestInit = {},
  contentType = 'application/json',
): Promise<Response> => {
  const url = getApiURL(endpoint, queryParams);
  const token = getQueryParam('token');
  return fetch(url, {
    ...init,
    // @ts-expect-error:next-line
    headers: {
      ...init.headers,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'Content-Type': contentType,
      ...(PG_API_ENDPOINTS.includes(endpoint)
        ? {}
        : {
            token,
          }),
    },
  });
};

export default api;
